import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgCompleet = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <g clipPath="url(#Compleet_svg__a)">
      <mask
        id="Compleet_svg__b"
        width={28}
        height={28}
        x={6}
        y={6}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M20 6a14 14 0 1 0 0 28 14 14 0 0 0 0-28m-1 21.74-7.25-6.06 1.92-2.3 4.88 4.08 7.85-10 2.36 1.85z"
        />
      </mask>
      <g mask="url(#Compleet_svg__b)">
        <path
          fill="#F7A941"
          d="M22.77 15.46 10.53 8.39 17.6-3.86zM-1.72 1.32l12.25 7.07-7.07 12.24z"
        />
        <path
          fill="#F7A941"
          d="m3.46 20.63 7.07-12.24 12.24 7.07z"
        />
        <path
          fill="#F18700"
          d="M17.6-3.86 10.53 8.39-1.72 1.32zM42.09 10.28 29.85 3.21l7.07-12.25z"
        />
        <path
          fill="#F7A941"
          d="m17.6-3.86 12.25 7.07-7.08 12.25z"
        />
        <path
          fill="#F18700"
          d="m22.77 15.46 7.08-12.25 12.24 7.07zM22.77 15.46l12.25 7.07-7.07 12.25z"
        />
        <path
          fill="#F18700"
          d="m42.09 10.28-7.07 12.25-12.25-7.07z"
        />
        <path
          fill="#F7A941"
          d="m27.95 34.78 7.07-12.25 12.25 7.07z"
        />
        <path
          fill="#F18700"
          d="M3.46 20.63 15.7 27.7 8.63 39.95z"
        />
        <path
          fill="#F7A941"
          d="M27.95 34.78 15.7 27.7l7.07-12.24z"
        />
        <path
          fill="#F7A941"
          d="M22.77 15.46 15.7 27.7 3.46 20.63z"
        />
        <path
          fill="#F18700"
          d="M8.63 39.95 15.7 27.7l12.25 7.08z"
        />
        <path
          fill="#F7A941"
          d="m8.63 39.95-12.25-7.07 7.08-12.25z"
        />
        <path
          fill="#F7A941"
          d="m-10.69 45.13 7.07-12.25 12.25 7.07z"
        />
        <path
          fill="#F18700"
          d="M47.27 29.6 40.2 41.85l-12.25-7.07z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="Compleet_svg__a">
        <path
          fill="#fff"
          d="M0 0h40v40H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgCompleet);

export default ForwardRef;
